import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

/**
 * Hook to check if reduced motion is enabled for accessibility
 * @returns boolean indicating if reduced motion is enabled
 */
export const useIsReducedMotionEnabled = (): boolean => {
    const [isReducedMotionEnabled, setIsReducedMotionEnabled] = useState(false);

    useEffect(() => {
        void AccessibilityInfo.isReduceMotionEnabled().then(setIsReducedMotionEnabled);
        const subscription = AccessibilityInfo.addEventListener(
            'reduceMotionChanged',
            setIsReducedMotionEnabled,
        );
        return () => subscription?.remove();
    }, []);

    return isReducedMotionEnabled;
};
